import React from 'react';
import { useSelector } from 'react-redux';

// Packages
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

// Utils
import errorExists from '../../utils/errorExists';

const DownloadReportButton = ({ report, onClick }) => {
	const { download_report_loading, download_report_success, reports_errors } = useSelector(state => state.reports);

	const reportId = report._id.$oid;
	const isLoading = download_report_loading.loading && download_report_loading.report_id === reportId;
	const isError = errorExists(reports_errors, 'download_report') && download_report_loading.report_id === reportId;
	const isSuccess = download_report_success?.success && download_report_success?.report_id === reportId;
	const hasOverlay = isLoading || isError || isSuccess;

	const buttonClass = isError ? 'danger-btn' : isSuccess ? 'success-btn' : 'submit-btn';

	return (
		<Button
			className={`fw-bold me-5 ${buttonClass}`}
			style={{ position: 'relative', minWidth: '170px' }}
			onClick={() => onClick(report)}
		>
			<span style={{ visibility: hasOverlay ? 'hidden' : 'visible' }}>
				<i className='bi bi-download bi-bold-download me-2'></i> {report.name}
			</span>
			{hasOverlay && (
				<span style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					{isLoading && <span className='spinner-border' role='status' aria-hidden='true' style={{ width: '1rem', height: '1rem', borderWidth: '2px' }} />}
					{isError && <span><i className='bi bi-x-lg bi-bold me-2'></i> Error</span>}
					{isSuccess && <span><i className='bi bi-check-lg bi-bold me-2'></i> Descarga lista</span>}
				</span>
			)}
		</Button>
	);
};

DownloadReportButton.propTypes = {
	report: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired
};

export default DownloadReportButton;
